
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
import ToolbarButton from '@/components/Toolbar/ToolbarButton.vue'
import { ColorPicker } from 'vue-color-kit'
import Range from '@/components/Common/Forms/Range.vue'
import ToolbarSlot from '@/components/Toolbar/ToolbarSlot.vue'

export default defineComponent({
    name: 'TextToolbar',
    components: {
        ToolbarSlot,
        Range,
        ToolbarButton,
        ColorPicker
    },
    props: {
        fontColor: {
            required: false,
            type: String,
            default: '#000000'
        },
        fontSize: {
            required: false,
            type: Number,
            default: 16
        }
    },
    emits: ['update:fontColor', 'update:fontSize', 'cancel', 'confirm', 'remove'],
    setup (props, { emit }) {
        const showColor = ref(false)

        const clickOutside = (e: Event) => {
            const el = e.target as HTMLElement

            if (!el.classList.contains('button-picker') && !el.closest('.button-picker') && !el.classList.contains('color-picker') && !el.closest('.color-picker')) {
                showColor.value = false
            }
        }

        const updateFontSize = (value: number) => {
            emit('update:fontSize', value)
        }

        const updateFontColor = (value: string) => {
            emit('update:fontColor', value)
        }

        const cancel = () => emit('cancel')
        const confirm = () => emit('confirm')
        const remove = () => emit('remove')

        onMounted(() => {
            document.addEventListener('click', clickOutside)
        })

        onUnmounted(() => {
            document.removeEventListener('click', clickOutside)
        })

        return {
            cancel,
            confirm,
            remove,
            showColor,
            updateFontColor,
            updateFontSize
        }
    }
})
